/* import __COLOCATED_TEMPLATE__ from './segmented-control.hbs'; */
import { computed, get } from '@ember/object';
import Component from '@ember/component';

/**

A horizontal control consists of clickable segments used to toggle between one or more modes

```example
@title Basic Example

@controller-properties
{
  options: ['%', '$'],

  selectedOptionValue: '%',

  actions: {
    segmentSelected(segment) {
      this.set('selectedOptionValue', segment);
      // Do other stuff
    }
  }
}

@hbs
{{segmented-control options=options
                    value=selectedOptionValue
                    action=(action 'segmentSelected')}}
```

```example
@title More than 2 options

@controller-properties
{
  options: ['Email Receipt', 'Print Receipt', 'No Receipt'],

  selectedOptionValue: 'No Receipt',

  actions: {
    segmentSelected(segment) {
      this.set('selectedOptionValue', segment);
      // Do other stuff
    }
  }
}

@hbs
{{segmented-control options=options
                    value=selectedOptionValue
                    action=(action 'segmentSelected')}}
```

@param {Object} options - Can be an array of objects or array of simple values.
@param {Object} value - The selected option
@param {String} labelPath - An optional path specifying the displaying content retrieved by `options.get(labelPath)`.
@param {String} segmentClass - Optional custom class to apply to segments.
*/

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  classNames: ['segmented-control'],
  // arguments to pass in
  options: null,
  value: null,
  segmentClass: null,
  // supply a key to the label if your options consist of dictionaries, not simple values
  labelPath: null,
  labelsAndValues: computed('options.[]', 'labelPath', function () {
    const labelPath = this.get('labelPath');
    return this.get('options').map(option => {
      const label = labelPath ? get(option, labelPath) : option;
      return {
        value: option,
        label
      };
    });
  })
});